import AppShell from "@/components/layout/AppShell";
import { PayrollSubtab } from "@/components/invoicing/PayrollSubtab";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import FeatureGate from "@/components/FeatureGate";

const PayrollPage = () => {
  const { user, organization } = useAuth();
  const { language } = useLanguage();
  const pageTitle = language === 'es' ? 'Nómina' : 'Payroll';
  
  return (
    <AppShell pageTitle={pageTitle}>
      <FeatureGate feature="payroll_hub">
        <div className="p-4 md:p-6 max-w-7xl mx-auto">
          <PayrollSubtab user={user} organization={organization} />
        </div>
      </FeatureGate>
    </AppShell>
  );
};

export default PayrollPage;
